import createDomNode from '../functions/createDomNode';
import getCookie from '../functions/getCookie';
import translations from '../config/translations';
import consentTypes from './consentTypes';

export default (consentType) => {
    const domElement = createDomNode('div', 'cookie-consent-select-inner-wrapper');

    const elementInput = createDomNode('input', 'cookie-consent-select-input');
    elementInput.id = consentType;
    elementInput.setAttribute('type', 'checkbox');

    if (getCookie(`consent-type-${consentType}`) || consentType === consentTypes.CONSENT_TYPE_NECESSARY) {
        elementInput.setAttribute('checked', 'checked');
    }

    if (consentType === consentTypes.CONSENT_TYPE_NECESSARY) {
        elementInput.setAttribute('disabled', 'disabled');
    }

    const elementLabel = createDomNode('label');
    elementLabel.setAttribute('for', consentType);
    elementLabel.innerText = translations.consentTypes[consentType].label;

    domElement.innerHTML = elementInput.outerHTML;
    domElement.innerHTML += elementLabel.outerHTML;

    return domElement;
};
